import React from 'react';
import { SectionWrapper } from './Shared';
export const HowItWorksSection = () => {
  const phases = [{
    num: '01',
    title: 'Fase de Eliminación',
    desc: 'Cortamos los 3 asesinos que están saboteando tus hormonas ahora mismo.'
  }, {
    num: '02',
    title: 'Fase de Activación',
    desc: 'Instalamos los hábitos de sueño y nutrición que encienden tu motor físico.'
  }, {
    num: '03',
    title: 'Fase de Optimización',
    desc: 'Consolidamos tu nuevo nivel de energía y enfoque para que dure toda la vida.'
  }];
  return <SectionWrapper className="bg-dark-800 border-y border-white/5" data-id="element-92">
      <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-93">
        <h2 className="font-oswald text-4xl md:text-5xl font-bold text-white uppercase tracking-tight" data-id="element-94">
          Cómo <span className="text-gold-500" data-id="element-95">Funciona</span>
        </h2>
      </div>

      <div className="max-w-4xl mx-auto" data-id="element-96">
        <div className="relative" data-id="element-97">
          {/* Timeline Line */}
          <div className="hidden md:block absolute left-[40px] top-0 bottom-0 w-px bg-white/10" data-id="element-98"></div>

          <div className="space-y-12" data-id="element-99">
            {phases.map((phase, idx) => <div key={idx} className="relative flex flex-col md:flex-row gap-6 md:gap-12 items-start" data-id="element-100">
                <div className="flex items-center gap-6 md:w-auto z-10" data-id="element-101">
                  <div className="w-20 h-20 rounded-full bg-dark-900 border-2 border-gold-500 flex items-center justify-center shrink-0 shadow-[0_0_20px_rgba(212,165,116,0.2)]" data-id="element-102">
                    <span className="font-oswald text-2xl font-bold text-gold-500" data-id="element-103">
                      {phase.num}
                    </span>
                  </div>
                </div>
                <div className="bg-dark-900 border border-white/5 p-8 rounded-2xl flex-1 hover:border-gold-500/30 transition-colors w-full" data-id="element-104">
                  <h3 className="font-oswald text-2xl font-bold text-white uppercase mb-3" data-id="element-105">
                    {phase.title}
                  </h3>
                  <p className="text-zinc-400 text-lg" data-id="element-106">{phase.desc}</p>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </SectionWrapper>;
};